import React from 'react';
import usePageTitle from '@src/hooks/usePageTitle';
import Content from './Content';

const SavedDashboards = () => {
  usePageTitle({ text: 'Saved Dashboards' });
  return (
    <Content />
  );
};
export default SavedDashboards;
